import { rem } from "polished";
import styled from "styled-components";

export const VideoContainer = styled.div`
  padding: ${rem(16)};
  z-index: var(--z-index-lowest);
  margin-left: -${rem(16)};
  margin-right: -${rem(16)};
  aspect-ratio: 16 / 9;

  @supports not (aspect-ratio: 16 / 9) {
    position: relative;
    padding: unset;
    padding-top: calc(100% / (16 / 9));
    margin-top: ${rem(40)};
    margin-bottom: ${rem(40)};
    > :first-child {
      position: absolute;
      inset: 0;
      padding: ${rem(16)};
    }
  }
`;
